import _ from "lodash";
import {
  Component,
} from "react";
import {
  Button,
  ListGroup,
  ListGroupItem,
  Modal,
} from "react-bootstrap";

import store from "CommonState/store";

import antragApi from "Apis/antrag-api";
import {
  schema,
} from "Apis/notiz-api";

import {
  Awesome,
  EditPanel,
  formatValue,
  Panel,
} from "CommonComponents/bricks";
import {
  formatDate,
} from "CommonCore/l10n";
import {
  createInjectsSelector,
  defaultFromSchema,
  injectsFromSchemaAndRenderMethods,
} from "CommonCore/schema-util";
import Confirmation from "CommonComponents/confirmation";
import apifetch from "CommonCore/apifetch";
import {
  ROLLEN,
  SICHTBARKEIT,
  userAntragsteller,
  userPersonalrat,
  userRollePersonalrat,
} from "App/constants";
const TableRenderMethods = {};

const injects = injectsFromSchemaAndRenderMethods(schema, TableRenderMethods);
const selectInjects = createInjectsSelector(injects);

@store("k_sichtbarkeitLookup", "k_nutzerLookup", "user")
export class AntragNotizEditor extends Component {
  constructor() {
    super();
    this.state = { edits: {} };
  }

  get entityNotiz() {
    const { notiz } = this.props;
    let entity = {};
    if (notiz) {
      entity = _.clone(notiz);
    }
    entity = _.assign(entity, this.state.edits);
    return _.assign(defaultFromSchema(schema, selectInjects(this.props), entity), entity);
  }


  render() {
    const { onClose, ast, rolle, user } = this.props;

    const myschema = _.cloneDeep(schema);
    const fld = myschema.table.find(f => f.field == "no_ksiid");
    if (ast) {
      // Für Ast Auswahl der Rollen-/Unisichtbarkeit entfernen
      fld.choices = lookup => lookup && _.map(_.omit(lookup, [SICHTBARKEIT.SICHTBAR_FÜR_ROLLE, SICHTBARKEIT.SICHTBAR_FÜR_UNI, SICHTBARKEIT.SICHTBAR_FÜR_ROLLE_UND_PA, SICHTBARKEIT.SICHTBAR_FÜR_ROLLE_SBV_PA_PR]), l => ({ value: l.ksi_id, label: l.ksi_kbez }));
    } else {
      // PBP-1472: Wenn nicht PR oder GSB, Sichtbarkeit "für Rolle + PR " weglassen.
      if (rolle != ROLLEN.ROLLE_GLEICHSTELLUNG && !userRollePersonalrat(rolle)) {
        fld.choices = lookup => lookup && _.map(_.omit(lookup, [SICHTBARKEIT.SICHTBAR_FÜR_ROLLE_UND_PA]), l => ({ value: l.ksi_id, label: l.ksi_kbez }));
      }
      // Bei Schwerbehindertenvertretung Sichtbarkeit "für alle" entfernen.
      if (rolle == ROLLEN.ROLLE_SBV) {
        fld.choices = lookup => lookup && _.map(_.omit(lookup, [SICHTBARKEIT.SICHTBAR_FÜR_ALLE]), l => ({ value: l.ksi_id, label: l.ksi_kbez }));
      }

      // Dez. 1.3 und Außenwirtschaft sollen nur "Für alle sichtbar", "Für meine Rolle sichtbar" und "Nur für mich sichtbar" wählen können.
      if (rolle == ROLLEN.ROLLE_DEZ1_3 || rolle == ROLLEN.ROLLE_AUSSENWIRTSCHAFT) {
        fld.choices = lookup => lookup && _.map(_.pick(lookup, [SICHTBARKEIT.SICHTBAR_FÜR_ALLE, SICHTBARKEIT.SICHTBAR_FÜR_ROLLE, SICHTBARKEIT.SICHTBAR_FÜR_MICH]), l => ({ value: l.ksi_id, label: l.ksi_kbez }));
      }

      // PBP-3087: Ankreuzfeld für Mailbenachrichtigung
      if (!userAntragsteller(user) && !userPersonalrat(user)) {
        myschema.table.push({ field: "info_mail",
                              display: "E-Mail-Benachrichtigung",
                              type: "checkbox" });
      }
    }

    return (
      <Modal show onHide={onClose}>
        <Modal.Header>
          Notiz bearbeiten
        </Modal.Header>
        <Modal.Body>

          <EditPanel
            editable
            defaultEditable
            action='Speichern'
            schema={myschema}
            injects={_.assign(selectInjects(this.props))} // getEntity für Schema-Funktionen injecten
            entity={this.entityNotiz}
            onClose={this.onClose}
            onChange={this.onChange}
            onSave={this.saveNotiz}
          />
        </Modal.Body>
      </Modal>
    );
  }

  onClose = () => {
    this.props.onClose();
  };

  onChange = change => {
    const { edits } = this.state;
    _.assign(edits, change);
    this.setState({ edits });
  };

  saveNotiz = async() => {
    // hier Speichern
    const { user, antrag } = this.props;

    const entity = this.entityNotiz;

    entity.no_aid = antrag;
    entity.no_nid = user.n_id;

    try {
      let append = "";
      if (userAntragsteller(user) || userPersonalrat(user) || entity.info_mail) {
        append = "?info=t";
      }

      delete entity.info_mail;
      await apifetch(`/api/shkantrag/notiz${ append }`, { method: "POST", body: entity });
      this.props.onClose();
    } catch(err) {
      const e = Error();
      e.response = { nachricht: "Fehler beim Speichern" };
      throw e;
    }
  };
}

@store(...injects, "user", "k_nutzerLookup", "k_sichtbarkeitLookup", "rolleLookup")
export class AntragNotizenTable extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      data,
      onDelete,
      onEdit,
      user,
      readonly,
      k_nutzerLookup,
      k_sichtbarkeitLookup,
      rolleLookup,
    } = this.props;

    return <ListGroup>{_.map(data, (record, index) => {
      const nutzer = k_nutzerLookup && _.get(k_nutzerLookup, record.no_nid, {}) || {};
      const canEdit = !readonly && user && user.n_id == record.no_nid;
      let sichtbarkeit = k_sichtbarkeitLookup && _.get(k_sichtbarkeitLookup, record.no_ksiid, {}) || {};

      if (sichtbarkeit && sichtbarkeit.ksi_id == SICHTBARKEIT.SICHTBAR_FÜR_ROLLE) {
        // Bei Sichtbarkeit für Rolle den Namen der Rolle anzeigen
        sichtbarkeit = `nur für ${ rolleLookup && _.get(rolleLookup, [user.ro_id, "ro_kbez"], {}) } sichtbar`;
      } else {
        sichtbarkeit = sichtbarkeit.ksi_kbez;
      }

      return <ListGroupItem key={index}>
        <p><span style={{ color: "#808080", fontSize: "small" }}>{`${ nutzer.n_name } ${ nutzer.n_vorname }, ${ formatDate(record.no_crdate) }`}</span></p>
        {canEdit && <Button className='float-end' variant='link' onClick={onDelete(index)}><Awesome name='trash' /></Button>}
        {canEdit && <Button className='float-end' variant='link' onClick={onEdit(index)}><Awesome name='pencil-alt' /></Button>}
        <p style={{ paddingLeft: "0.51em" }}>{formatValue(record, schema.table.find(x => x.field == "no_text"))}</p>
        <p><span style={{ color: "#808080", fontSize: "small" }}>{`${ sichtbarkeit }`}</span></p>
      </ListGroupItem>;
    })}</ListGroup>;
  }
}

@antragApi.current
@store("k_sichtbarkeitLookup", "k_nutzerLookup")
export default class AntragNotizenWidget extends Component {
  constructor() {
    super();
    this.state = { data: [], editMode: false, newMode: false };
  }

  async refetch(a_id) {
    if (a_id && a_id != "undefined") {
      this.setState({ inflight: true });
      const data = await apifetch(`/api/shkantrag/notiz/${ a_id }`);
      this.setState({ data: data.data, inflight: false });
    }
  }

  componentDidMount() {
    const { antrag } = this.props;
    this.refetch(antrag.a_id);
  }

  onNew = () => {
    this.setState({ newMode: true, editNotiz: null });
  };

  onEdit = id => () => {
    // Edit beginnen
    this.setState({ editMode: true, editNotiz: id });
  };

  render = () => {
    const { currentAntrag, readonly, ast, rolle } = this.props;
    const { data, newMode, editMode, editNotiz, deleteMode, deleteId } = this.state;

    return (<Panel header='Notizen zum Antrag'>

      { !readonly && (newMode || (editMode && editNotiz >= 0)) && <AntragNotizEditor rolle={rolle} ast={ast} antrag={currentAntrag.a_id} notiz={editMode ? data[editNotiz] : null} onClose={this.endEdit} />}

      { deleteMode && <NotizLoeschen no_id={deleteId} onClose={this.endEdit} />}

      <AntragNotizenTable
        data={this.state.data}
        inflight={this.state.inflight}
        onDelete={this.beginDelete}
        onEdit={this.onEdit}
        {...this.props} />

      {!readonly && <Button variant='outline-primary' onClick={this.onNew}>Notiz hinzufügen</Button>}

    </Panel>);
  };
  endEdit = () => {
    this.setState({ deleteMode: false, newMode: false, editMode: false });
    const { currentAntrag } = this.props;
    this.refetch(currentAntrag.a_id);
    this.forceUpdate();
  };

  beginDelete = id => () => {
    // Popup anzeigen lassen
    this.setState({ deleteMode: true, deleteId: this.state.data[id].no_id });
  };
}

@store("currentNotizflight")
class NotizLoeschen extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { onClose, currentAntragInflight: inflight } = this.props;
    const { deleteFailedMessage } = this.state;

    return (
      <Confirmation
        header='Notiz löschen'
        body='Sind Sie sicher, dass Sie die Notiz unwiderruflich löschen möchten?'
        action='Löschen'
        inflight={inflight}
        onCancel={onClose}
        onConfirm={this.onConfirm}
        errorMessage={deleteFailedMessage}
      />
    );
  }

  onConfirm = async() => {
    // Notiz löschen
    const no_id = this.props.no_id;
    try {
      await apifetch(`/api/shkantrag/notiz/${ no_id }`, { method: "DELETE" });
      this.endEdit();
    } catch(err) {
      this.setState({
        deleteFailedMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
    this.props.onClose();
  };
}
